import React from 'react';
import { getAPIData, getAPIDataParams } from '../../../utils/apiFunction';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from "@mui/material/TextField";


const RoleSelect = (props) => {
    const [role, setRole] = React.useState([]);
    const [value, setValue] = React.useState(props.state);
    const [inputValue, setInputValue] = React.useState('');

    const filterVals = (list) => {
        setRole(list.sort((a, b) => {
            return a.name > b.name ? 1 : -1;
        }));
    }

    React.useEffect(() => {
        console.log("RoleId", props.roleId);
        if (props.roleId) {
            var est = role.find((dr) => { return (dr.id === props.roleId) });
            props.setState(est);
            setValue(est);
        }
        console.log("RoleList", role);
    }, [role, props.roleId])

    React.useEffect(() => {
        getAPIData('/Roles/Get', filterVals);
     }, [])

    return (<Autocomplete
        value={value}
        disabled={props.disabled}
        onChange={(event, newValue) => {
            props.setState(newValue);
            setValue(newValue);
        }}
        inputValue={inputValue}
        onInputChange={(event, newInputValue) => {
            setInputValue(newInputValue);
        }}
        getOptionLabel={(option) => option.name}
        disablePortal
        id="rolebox"
        options={role}
        sx={props.widthAuto?{width:'auto'}:{ width: 300 }}
        renderInput={(params) => <TextField {...params} label="Role" />}
    />);
}
export default RoleSelect;